import React from 'react';
import { Flex, Text, useBreakpointValue } from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { Monitor } from 'lucide-react';

type DesktopOnlyGuardProps = {
  children: React.ReactNode;
  title?: string;
  description?: string;
};

export const DesktopOnlyGuard: React.FC<DesktopOnlyGuardProps> = ({
  children,
  title = 'Desktop view required',
  description = 'This feature is optimized for larger screens. Please switch to a desktop device to access it.',
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  if (isMobile) {
    return (
      <Flex
        direction="column"
        align="center"
        justify="center"
        py={16}
        px={4}
        textAlign="center"
        gap={4}>
        <ChakraIcon as={Monitor} boxSize={10} color="gray.400" />
        <Text
          fontFamily="marketingPage"
          fontWeight="semibold"
          fontSize="lg"
          color="text.darkBlue.900">
          {title}
        </Text>
        <Text fontFamily="marketingPage" fontSize="sm" color="text.darkGray">
          {description}
        </Text>
      </Flex>
    );
  }

  return <>{children}</>;
};
